import React from 'react';

const getEnv = (key) => {
  try {
    if (import.meta && import.meta.env && import.meta.env[key]) return import.meta.env[key];
  } catch (e) {}
  try {
    if (typeof process !== 'undefined' && process.env && process.env[key]) return process.env[key];
  } catch (e) {}
  return undefined;
};

const AboutPopup = ({ show = false, onClose = () => {} }) => {
  if (!show) return null;

  const environment = getEnv('VITE_APP_ENV') || getEnv('VITE_APP_ENVIRONMENT') || 'production';
  const version = getEnv('VITE_APP_VERSION') || 'Unknown';
  const versionDate = getEnv('VITE_APP_VERSION_DATE') || 'Unknown';

  const firebaseProjectId = getEnv('VITE_FIREBASE_PROJECT_ID') || 'unknown-project';
  const projectUrl = getEnv('VITE_FIREBASE_PROJECT_URL') || '-';

  // Table-friendly styles: left-aligned labels, left values, allow wrapping
  const tableStyle = { width: '100%', borderCollapse: 'collapse' };
  const labelStyle = { width: '40%', textAlign: 'left', padding: '6px 8px', verticalAlign: 'top', color: '#444', fontSize: 13, whiteSpace: 'nowrap', fontWeight: 700 };
  const valueStyle = { width: '60%', textAlign: 'left', padding: '6px 8px', verticalAlign: 'top', color: '#111', fontSize: 13, wordBreak: 'break-word', whiteSpace: 'normal' };

  return (
    <div className="about-popup-overlay" onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.35)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 6000 }}>
      <div className="about-popup" onClick={(e) => e.stopPropagation()} style={{ background: '#fff', borderRadius: 8, width: '520px', maxWidth: '96%', padding: 20, boxShadow: '0 10px 30px rgba(0,0,0,0.2)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <h3 style={{ margin: 0, color: '#000' }}>About ICNACON</h3>
          <button onClick={onClose} style={{ background: 'transparent', border: 'none', fontSize: 20, cursor: 'pointer' }} aria-label="Close">×</button>
        </div>

        <table style={tableStyle}>
          <tbody>
            <tr>
              <td style={labelStyle}>Environment</td>
              <td style={valueStyle}>{environment}</td>
            </tr>
            <tr>
              <td style={labelStyle}>Version</td>
              <td style={valueStyle}>{version}</td>
            </tr>
            <tr>
              <td style={labelStyle}>Version Date</td>
              <td style={valueStyle}>{versionDate}</td>
            </tr>
            <tr>
              <td style={labelStyle}>Firebase Project ID</td>
              <td style={valueStyle}>{firebaseProjectId}</td>
            </tr>
            <tr>
              <td style={labelStyle}>Project Host URL</td>
              <td style={valueStyle}>{projectUrl}</td>
            </tr>
          </tbody>
        </table>

        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 12 }}>
          <button onClick={onClose} className="new-layout-btn">Close</button>
        </div>
      </div>
    </div>
  );
};

export default AboutPopup;
